import styled from 'styled-components';

export const InputArea = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  width: 100%;
`;

export const ConteinerInput = styled.div`
  display: flex;

  width: 100%;
`;

export const BordaInput = styled.span`
  position: absolute;
  top: 50px;

  width: ${(props) => (props.error ? '100%' : 0)};
  height: 2px;

  background-color: ${(props) => (props.error ? props.theme.DANGER : props.theme.PRIMARY)};

  transition: 0.4s;
`;

export const CampoInput = styled.input`
  width: 100%;
  padding: 7px 0 2px 5px;

  color: ${(props) => props.theme.DARK};
  background-color: ${(props) => props.theme.MEDIUM};
  border: 0;
  border-bottom: 1px solid #ccc;
  border-radius: 5px 5px 0px 0px;
  box-sizing: border-box;

  font:
    15px/24px 'Lato',
    arial,
    sans-serif;
  letter-spacing: 1px;

  &:focus {
    outline: none;
    outline-offset: 0;
  }

  &:focus ~ ${BordaInput} {
    width: 100%;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

export const ConteinerIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 0 10px;
`;

export const TextoDeErro = styled.span`
  color: ${(props) => props.theme.DANGER};
`;
